/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/
import React from 'react';

import FormContainer from 'components/FormContainer';
import Button, { ButtonContainer } from 'components/Button';
import { FormSectionGlobal as FormSection, Label } from '@fitinsur/components';

import { GeneralSection } from '../../general/index';

function RenderSection({
  formikProps,
  formikRef,
  idProduct,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  teamsGroup,
  setTeamsGroup,
  teamsGroupToDelete,
  setTeamsGroupToDelete,
  contactsGroup,
  setContactsGroup
}) {
  const handleArrow = (arrowDirection, index) => {
    const newHierarchyGroup = [...teamsGroup];
    if (arrowDirection === 'up' && index > 0) {
      [newHierarchyGroup[index - 1], newHierarchyGroup[index]] = [newHierarchyGroup[index], newHierarchyGroup[index - 1]];

    } else if (arrowDirection === 'down' && index < teamsGroup.length - 1) {
      [newHierarchyGroup[index + 1], newHierarchyGroup[index]] = [newHierarchyGroup[index], newHierarchyGroup[index + 1]];
    }
    
    setTeamsGroup(newHierarchyGroup.map((questions, groupIndex) => {
      questions = questions.map(qst => {
        if ([2184, 2185, 2186, 2187, 2188].includes(qst.idQuestion)) {
          qst.behaviorObject.extraDescriptionTop = groupIndex === 0 ? qst.dsQuestion : '';
        }
        return qst;
      })
      return questions;
    }));
  };

  return (
    <FormContainer show={true} title="Teams">
      {teamsGroup.map((questions, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', width: '100%', paddingRight: "5px" }}>
          <div style={index !== 0 ? {paddingTop: '16px'} : {}}>
            {index === 0 && <Label style={{ width: "140px", whiteSpace: "nowrap", textAlign: "center" }}>Display Order</Label>}
            <GeneralSection.components.renderDisplayOrder 
              index={index}
              groupLength={teamsGroup.length}
              handleArrow={handleArrow}
              componentStyle={index === 0 ? {height: '48px'} : {}}
            />
          </div>
          <div style={{ flex: 1 }}>
            <FormSection
              key={index}
              sectionIndex={index}
              sectionName="TEAMS"
              errors={formikProps.errors}
              questionnaire={questions}
              setQuestionnaire={(questionnaire) => setTeamsGroup(teamsGroup.map((v, i) => i === index ? questionnaire : v))}
              values={formikProps.values}
              setFieldValue={formikProps.setFieldValue}
              setFieldError={formikProps.setFieldError}
              formikRef={formikRef}
              idProduct={idProduct}
              extraButtonsAfterQuestion={(question) => {
                if (question.idQuestion !== 2183) return null;
                return (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '80px'
                  }}>
                    {
                      GeneralSection.components.renderSectionAddAndRemoveRowButtons({
                        sectionState: teamsGroup,
                        setSectionState: setTeamsGroup,
                        index,
                        questions,
                        teamsGroupToDelete,
                        setTeamsGroupToDelete,
                        onRemove: ({idPersonTeam}) => {
                          if (idPersonTeam && contactsGroup) {
                            setContactsGroup && setContactsGroup(contactsGroup.filter(
                              team => team.idPersonTeam !== idPersonTeam
                            ));
                          }
                        }
                      })
                    }
                  </div>
                );
              }}
            />
          </div>
        </div>
      ))}
    </FormContainer>
  )
}

const components = {
  RenderSection
};

export { components };